<template>
  <div class="bc-toggle">
    <a href="https://notebooklm.google.com/notebook/17eaa91e-7d1c-4dfc-a811-8b098e9f32c9?pli=1" target="_blank">
      <span>IA</span>
      <fa :icon="['fas', 'sparkles']" />
    </a>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  @property --c1 { syntax: '<color>'; inherits: false; initial-value: #051937; }
  @property --c2 { syntax: '<color>'; inherits: false; initial-value: #602e61; }
  @property --c3 { syntax: '<color>'; inherits: false; initial-value: #bb4162; }
  @property --c4 { syntax: '<color>'; inherits: false; initial-value: #f27b3f; }
  @property --c5 { syntax: '<color>'; inherits: false; initial-value: #ebce12; }

  .bc-toggle {
    margin-top: $mg_large;
    padding: $hmg_mid $mg_mini;
    position: absolute !important; bottom: 100px;

    a {
      display: flex; align-items: center; justify-content: center;
      gap: 2px;
      padding: 8px;
      line-height: 1;
      border-radius: 2em;
      // background-image: linear-gradient(to right top, #051937, #602e61, #bb4162, #f27b3f, #ebce12);
      text-align: center;
      color: $color-secondary;
      font-weight: 600;
      --c1: #051937;
      --c2: #602e61;
      --c3: #bb4162;
      --c4: #f27b3f;
      --c5: #ebce12;
      background: linear-gradient(to right top, var(--c1), var(--c2), var(--c3), var(--c4), var(--c5));
      transition:
        all .8s ease,
        --c1 .8s ease,
        --c2 .8s ease,
        --c3 .8s ease,
        --c4 .8s ease,
        --c5 .8s ease;

      span {
        font-size: 10px;
      }

      &:hover {
        box-shadow:
            0 4px 10px rgba(5, 25, 55, 0.2),
            0 8px 20px rgba(96, 46, 97, 0.3),
            0 12px 30px rgba(187, 65, 98, 0.3),
            0 16px 40px rgba(242, 123, 63, 0.25),
            0 20px 50px rgba(235, 206, 18, 0.2);
        
        --c1: #ebce12;
        --c2: #f27b3f;
        --c3: #bb4162;
        --c4: #602e61;
        --c5: #051937;
        // background-image: linear-gradient(to right top, #ebce12, #f27b3f, #bb4162, #602e61, #051937);
      }
     
    }
  }
</style>